import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDL3BLACKCROWS', label: 'Three Black Crows', lookback: 13 })
